// extracted by mini-css-extract-plugin
export default {"editoroptions":"CreatePost_editoroptions__y8+m+","postoptions":"CreatePost_postoptions__mm-ro"};